import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { ModalDismissReasons, NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { DealerOpeningHoursViewModel } from 'projects/Administration/src/app/business-entities/dealer-opening-hours-view-model';
import { GenericSchedulerListViewModel } from 'projects/Administration/src/app/business-entities/generic-scheduler-list-view-model';
import { MechanicDaySchedulerViewModel } from 'projects/Administration/src/app/business-entities/mechanic-day-schedule.model';
import { SaveAppointmentPlanning } from 'projects/Administration/src/app/business-entities/save-appointment-planning.model';
import { Features } from 'projects/Administration/src/app/business-entities/user-role-view-model';
import { AppointmentService } from 'projects/Administration/src/app/business-services/appointment.service';
import { DealerBusinessService } from 'projects/Administration/src/app/business-services/dealer.service';
import { EditAppointmentService } from 'projects/Administration/src/app/business-services/edit-appointment.service';
import { MechanicService } from 'projects/Administration/src/app/business-services/mechanic.service';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { NgbdModalContent } from 'projects/Autofacets-Core/src/app/shared/delete-modal.component';
import * as fromEnums from 'projects/Autofacets-Core/src/app/utils/enums';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import * as Enums from './../../../../../../../Autofacets-Core/src/app/utils/enums';
import { AppointmentScheduleModel } from './../../../../business-entities/appointment-schedule.model';
import { AppointmentScheduleRequestModel } from './../../../../business-entities/appointmentSchedule-request-model';
import { DealerHolidayViewModel } from './../../../../business-entities/dealer-holiday-list-view-model';
import { GenericDayHeader } from './../../../../business-entities/generic-day-header.model';
import { MechanicBookedAppointmentDetails } from './../../../../business-entities/mechanic-booked-appointment-details.model';
import { MechanicList } from './../../../../business-entities/mechanicList-model';
import { AppointmentPlanningService } from './../../../../business-services/appointment-planning.service';
import { AddBookingComponent } from './add-booking/add-booking.component';
import { AppointmentServiceDetails } from 'projects/Administration/src/app/business-entities/appointment-service-details-view-model';
import { WorkOrderStatus } from 'projects/Administration/src/app/business-entities/appointmentStatus-model';
import { SchedulerDayViewComponent } from 'projects/Administration/src/app/components/af-scheduler-day-view/scheduler-day-view.component';
import { CurrentLanguage } from 'projects/Autofacets-Core/src/app/common-services/current-language.service';
import { EnvSetting } from 'projects/Autofacets-Core/src/app/utils/env-setting';

@Component({
  selector: 'app-appointment-planning',
  templateUrl: 'appointment-planning.component.html',
  styleUrls: []
})
export class AppointmentPlanningComponent implements OnInit {
  appointmentId: number;
  @Output() loadErrorMessage= new EventEmitter<any>(); 
  dealerId: string;
  appointmentDate: Date;
  dealerWorkingHours: DealerOpeningHoursViewModel[] = [];
  dealerHolidays: DealerHolidayViewModel[] = [];
  mechanics: MechanicList[] = [];
  appointmentSchedule: AppointmentScheduleModel;
  genericDayHeaderViewModel: GenericDayHeader;
  selectedDate = new Date();
  genericSchedulerListViewModel: GenericSchedulerListViewModel[];
  dealerHolidayDates: Date[] = [];
  duration: number;
  daySchedulerViewModel: MechanicDaySchedulerViewModel;
  hours: Array<number> = [];
  totalDuration: number = 0;
  isEdit: boolean;
  isServicesAdded: boolean = false;
  totalServiceTime = 0;
  showAllMechanic: boolean = true;
  message: any;
  IsMessageDisplay: boolean = false;
  formattedtotalDuration: any;
  formattedtotalDurationDate:any;
  formatedTotalServiceTime;
  formatedTotalServiceTimeDate:any;
  isView:boolean=false;
  dealerName:string='';
  remainingDuration:any;
  isFromArchive? : boolean;
  isDmsSlotActive : boolean = false;
  calendarNumber: number = 0;
  reasonForDelete: string = '';
  isShareboxReminderNeeded: boolean = false;
  serviceDetail: AppointmentServiceDetails;
  isBlockMechanic = false;
  mechanicLeaveTypesList: any[] = [];
  dayViewScrollLeft: { scrollTop: number; scrollLeft: number } = { scrollTop: 0, scrollLeft: 0 };
  @ViewChild('dayViewRef') dayViewRef: SchedulerDayViewComponent;
  //Below code Added By Bhavesh
  schedulerModal: any;
  schedulerHeaderInfo: any;
  todayDate = new Date();
  features: Features[] = [];
  closeResult: string;
  bookingId:number;
  workOrderStatusList: WorkOrderStatus[];
  constructor(
    private appointmentPlanningService: AppointmentPlanningService,
    private mechanicService: MechanicService,
    private dealerService: DealerBusinessService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private datePipe: DatePipe,
    private model: NgbModal,
    private translate: TranslateService,
    private appointmentService: AppointmentService,
    private readonly editAppointmentService: EditAppointmentService,
    private activeModal: NgbActiveModal,
    private cdr: ChangeDetectorRef,
    private modalService: NgbModal,
    private secureStorage: SecureStorage,
    private currentLanguageService: CurrentLanguage
  ) { }

  ngOnInit(): void {
    this.isEdit = this.editAppointmentService.isEdit;
    this.setDataFromBusinessService();
    this.getAllDetails();
    this.GetMechanicLeaveTypes();
    this.currentLanguageService.currentLanguage.subscribe((res) => {
      this.GetAllWorkOrderStatus(res);
    });
  }

  GetMechanicLeaveTypes() {
    this.mechanicService.GetMechanicLeaveTypes().then((response: any) => {
      if (response?.responseObject?.length) {
        this.mechanicLeaveTypesList = response.responseObject.filter((x: any) => !x.isDeleted);
      }
    });
  }

  onDayViewScroll(scroll: { scrollTop: number; scrollLeft: number }): void {
    this.dayViewScrollLeft = scroll;
  }

  syncMechanicScroll(scrollTop: number): void {
    this.dayViewRef?.scrollTo(scrollTop);
  }

  setDataFromBusinessService(): void {
    this.selectedDate = this.editAppointmentService.appointmentDetails.bookedDateTime == null ? new Date() : new Date(this.editAppointmentService.appointmentDetails.bookedDateTime)
    this.appointmentId = this.editAppointmentService.appointmentDetails.id;
    this.dealerId = this.editAppointmentService.appointmentDetails.dealerId;
    this.dealerName = this.editAppointmentService.appointmentDetails.dealerName;
    this.appointmentDate = this.editAppointmentService.appointmentDetails.bookedDateTime == null ? new Date() : new Date(this.editAppointmentService.appointmentDetails.bookedDateTime);
    this.isFromArchive = this.editAppointmentService.appointmentDetails.isFromArchive;
  }

  async getAllDetails(): Promise<void> {
    if(!this.isFromArchive)
    {
      await this.GetAppointmentServiceDetail();
      await this.getDealerWorkingHoursAndHolidayList();
      //await this.getMechaicMonthwiseHours();
    }
    else{
      await this.getAppointmentSchedule(this.appointmentDate);
    }
    let features = this.secureStorage.getKeyData('feature');
    this.isDmsSlotActive = features.find(x => x.featureCode === Enums.FeatureCode.DmsSlots)?.isActive;
    this.isBlockMechanic = this.features.find(x => x.featureCode === Enums.FeatureCode.BlockMechanic)?.isActive;
  }
  GetAllWorkOrderStatus(language){
    let model={
      DealerId: this.dealerId,
      LanguageCode:language
    }
    this.appointmentService.GetAllWorkOrderStatus(model).then(data => {
      this.workOrderStatusList = data.responseObject.workOrderStatusList;
    })
  }
  async getMechaicMonthwiseHours(date?: Date) {
    this.spinner.show();
    if (date) {
      if (!isNaN(date.getTime())) {
        this.selectedDate = date;
      }
    }
    const getMechanicMonthwiseRequestParameter: any = {
      dealerId: this.dealerId,
      year: new Date(this.selectedDate).getFullYear(),
      month: new Date(this.selectedDate).getMonth() + 1,
      appointmentId: this.appointmentId,
      showAllMechanic: this.showAllMechanic
    }
    await this.appointmentPlanningService.getMechanicMonthwiseHours(getMechanicMonthwiseRequestParameter)
      .then((result) => {
        this.schedulerHeaderInfo = result.responseObject;
        let single = Object();
        single.headerInfo = this.schedulerHeaderInfo
        this.schedulerModal = single
      }).finally(()=>{
        this.spinner.hide();
      });
  }
  async getDealerWorkingHoursAndHolidayList(): Promise<void> {
    const resp = await this.dealerService.GetDealerWorkingHoursAndHoliday(this.dealerId);
    this.dealerWorkingHours = resp.responseObject.dealerOpeningHoursViewModel;
    this.appointmentPlanningService.dealerWorkingHours = this.dealerWorkingHours;
    this.dealerHolidays = resp.responseObject.dealerHolidayViewModel;
    this.appointmentPlanningService.dealerHolidays = this.dealerHolidays;
  }
  async getAllMechanics(): Promise<void> {
    await this.mechanicService.GetMechanicList(this.dealerId,Enums.StatusCode.All).then((response) => {
      this.mechanics = response.responseObject
    });
  }

  async getAppointmentSchedule(date?: Date): Promise<void> {
    if (date) {
      if (!isNaN(date.getTime())) {
        this.selectedDate = date;
      }
    }
    this.spinner.show();
    const offset = new Date().getTimezoneOffset();
    const utcDate = new Date(this.selectedDate.getTime() - (offset * 60 * 1000));
    const getAppointmentScheduleRequestParameter: AppointmentScheduleRequestModel = {
      dealerId: this.dealerId,
      date: this.datePipe.transform(this.selectedDate, 'yyyy-MM-dd'),
      appointmentId: this.appointmentId,
      showAllMechanic: this.showAllMechanic,
      isForMenu:false,
      isDmsSlotActive : this.isDmsSlotActive,
    }
    await this.appointmentPlanningService.getAppointmentScheduleDetails(getAppointmentScheduleRequestParameter)
      .then((result) => {
        this.IsMessageDisplay = false
        let response = result.responseObject;
        if(this.editAppointmentService.appointmentDetails != null){
          if(response.bookingDate == null){
            this.editAppointmentService.appointmentDetails.bookedDateTime = null;
            this.editAppointmentService.appointmentDetails.bookedDate = null;
          }
          else{
            this.editAppointmentService.appointmentDetails.bookedDateTime = response.bookingDate;
            this.editAppointmentService.appointmentDetails.bookedDate = new Date(response.bookingDate + 'Z');
          }
        }
        if (response.errorCount > 0) {
          this.appointmentSchedule = null;
          this.daySchedulerViewModel = null;
          this.genericSchedulerListViewModel = null;
          if(response.result.errorCode == '4007'){
            this.IsMessageDisplay = true;
            this.message = this.translate.instant("lblDealerNotAvailable")
            this.message += ' ' + Utility.GetFormattedDate(this.selectedDate);
          }
          else{
            if (getAppointmentScheduleRequestParameter.showAllMechanic === false) {
              this.IsMessageDisplay = true;
              this.message = this.translate.instant("lblMechanicNotForCompetence")
            }
            else {
              this.IsMessageDisplay = true;
              this.message = this.translate.instant("lblMechanicNotAvailable")
            }
          }
        } else {
          this.appointmentSchedule = result.responseObject;
 
          //sharebox reminder message code.
          const currentDateTime = new Date();  
          let date = null;  

          if (result.responseObject?.bookedMechanicList?.length > 0) {
            result.responseObject.bookedMechanicList.forEach((item: any) => {
              const bookedDateTime = Utility.ConvertUTCDateToLocalDate(item.startTime); 
              const timeDifferenceInHours = (bookedDateTime.getTime() - currentDateTime.getTime()) / (1000 * 60 * 60);

              if (timeDifferenceInHours <= 24 && timeDifferenceInHours>0) { 
                date = Utility.ConvertUTCDateToLocalDate(item.startDate);
              }
            });
          }

          this.onLoadErrorMessage(date); 

          let editableWorkOrderStatusId=[Enums.WorkOrderStatus.WorkRequest,Enums.WorkOrderStatus.Prepared,Enums.WorkOrderStatus.WaitingForCustomer];
          let isEditable= editableWorkOrderStatusId.filter(x=>Number(x) === this.editAppointmentService.appointmentDetails.workOrderStatusId)[0] ? true : false;
          this.appointmentSchedule.bookedMechanicList = this.appointmentSchedule.bookedMechanicList.map(x => {
            x.startTime = Utility.ConvertUTCDateToLocalDate(x.startTime)
            x.endTime = Utility.ConvertUTCDateToLocalDate(x.endTime)
            x.isDisable = (x.startTime <= new Date())?true:false;
            if(isEditable)
            {
              x.isDisable=false;
            }
            return x;
          });


          if (result.responseObject.mechanicShiftDetails.length > 0) {
            let single = Object();
            single.planningResources = this.schedulerResourceMapper(result.responseObject.mechanicShiftDetails);
            single.planningEvents = this.schedulerEventMapper(this.appointmentSchedule.bookedMechanicList, this.appointmentSchedule.mechanicShiftDetails);
            this.schedulerModal = single
          }
          if (this.appointmentSchedule.mechanicShiftDetails.length === 0) {
            if(this.totalServiceTime<=0){
              this.IsMessageDisplay = true;
              this.message = this.translate.instant("lblServiceNotAdded")
            }
            else{
              if (getAppointmentScheduleRequestParameter.showAllMechanic === false) {
                this.IsMessageDisplay = true;
                this.message = this.translate.instant("lblMechanicNotForCompetence")
              }
              else {
                this.IsMessageDisplay = true;
                this.message = this.translate.instant("lblMechanicNotAvailable")
              }
            }
          }
          else {
            this.appointmentSchedule.mechanicShiftDetails.forEach(mechanic => {
              mechanic.bookedAppointmentList.forEach(appointment => {
                appointment.appointmentStartTime = Utility.ConvertUTCDateToLocalDate(appointment.appointmentStartTime)
                appointment.appointmentEndTime = Utility.ConvertUTCDateToLocalDate(appointment.appointmentEndTime)
              })
            })
          }
          this.setGenericSchedulerList();
          this.setMechanicDaySchedulerViewModel();
          this.setHours();
          this.setTotalDuration();
        }
        this.cdr.detectChanges();
      }).finally(()=>{
        this.spinner.hide();
      });
  }

  async GetAppointmentServiceDetail() {
    await this.appointmentService.GetServiceDetail(this.editAppointmentService.appointmentDetails.id, "").then(data => {
      this.isServicesAdded = (data.responseObject?.errorCount !== 0);
      this.appointmentPlanningService.isServicesAdded = this.isServicesAdded
      if (data.responseObject?.errorCount !== 0) {
        this.totalServiceTime = data.responseObject.totalTime;
        this.serviceDetail = data.responseObject;
        this.formatedTotalServiceTime = Math.floor((this.totalServiceTime * 60) / 60)+'.'+Math.round((this.totalServiceTime * 60) % 60);
        const [h,m] = this.formatedTotalServiceTime.split('.');
        this.formatedTotalServiceTimeDate = new Date();
        this.formatedTotalServiceTimeDate.setHours(h);
        this.formatedTotalServiceTimeDate.setMinutes(m);
        this.remainingDuration = h + ":" + m
      }
    });
  }
  async schedulerMonthChange(date?: Date) {
    await this.getMechaicMonthwiseHours(date);
    await this.getAppointmentSchedule(date)
  }
  setGenericSchedulerList(): void {
    const list: GenericSchedulerListViewModel[] = [];
    this.appointmentSchedule.mechanicShiftDetails.forEach(mechanic => {
      let object: GenericSchedulerListViewModel = {
        pId: +mechanic.mechanicId,
        pText: mechanic.mechanicName,
        icon: mechanic.brandIcon,
        skillDescription: mechanic.skillDescription,
        isIconShow: true,
        iconLength: 0,
        isActive: mechanic.isActive,
        isOnLeave: mechanic.isOnLeave,
        leaveOption: mechanic.leaveOption,
        efficiency: mechanic.mechanicEfficiency,
        isCapacityPlanning: mechanic.isCapacityPlanning,
        competence:mechanic.competence
      };
      list.push(object);
    });
    this.genericSchedulerListViewModel = list.slice();
    this.genericSchedulerListViewModel = [...new Map(this.genericSchedulerListViewModel.map(item => [item.pId, item])).values()]
  }

  setMechanicDaySchedulerViewModel(): void {
    const mechanicShiftDetailsCopy = JSON.parse(JSON.stringify(this.appointmentSchedule.mechanicShiftDetails));
    const object = {
      date: this.selectedDate,
      dealerTimeSlots: this.getDealerTimeSlots(),
      mechanics: mechanicShiftDetailsCopy,
      dayAppointmentList: this.getDayAppointmentList()
    } as MechanicDaySchedulerViewModel;
    this.daySchedulerViewModel = object;
    let originalValues = new Map();
    for (let i of this.daySchedulerViewModel.mechanics) {
      if (originalValues.has(i.mechanicId)) {
        let temp = originalValues.get(i.mechanicId);
        temp.bookedAppointmentList.push(...i.bookedAppointmentList);
        originalValues.set(i.mechanicId, temp);
      } else {
        originalValues.set(i.mechanicId, i);
      }
    }
    this.daySchedulerViewModel.mechanics = [...originalValues.values()];
    this.daySchedulerViewModel.mechanics.forEach((mechanic)=>{
      let data = this.genericSchedulerListViewModel.filter(x=>x.pId === mechanic.mechanicId)[0]?.icon;
      if(data){
        data?.forEach(element => {
          mechanic.bookedAppointmentList?.forEach((appointment)=>{
            if(appointment.brandCode === element.brandCode)
            {
              appointment.brand = element.brandIcon
            }
          })
        });
      }
    })
  }

  getDealerTimeSlots(): string[] {
    let dealerSlots = [];
    let shiftStartTime = this.appointmentSchedule.dealerShiftDetails.shiftStart?this.datePipe.transform(this.appointmentSchedule.dealerShiftDetails.shiftStart, 'HH:mm'):"00:00";
    let shiftEndTime = this.appointmentSchedule.dealerShiftDetails.shiftEnd?this.datePipe.transform(this.appointmentSchedule.dealerShiftDetails.shiftEnd, 'HH:mm'):"00:00";
    // const startHours = +shiftStartTime?.split(":")[0]
    // const endHours = +(shiftEndTime?.split(":")[0])
    const startHours = +EnvSetting.PlanningFromTime;
    const endHours = +EnvSetting.PlanningToTime
    for (let i = startHours; i <= endHours; i++) {
      dealerSlots.push(`${i}:00`);
    }
    return dealerSlots;
  }

  getDayAppointmentList(): MechanicBookedAppointmentDetails[] {
    const totalAppointments = [];
    this.appointmentSchedule.mechanicShiftDetails.forEach(mechanic => {
      mechanic.bookedAppointmentList.forEach(appointment => {
        appointment.bookingId = mechanic.bookingId;
        totalAppointments.push(appointment);
      })
    });
    return totalAppointments;
  }

  setHours(): void {
    this.hours = [];
     let shiftStartTime = this.appointmentSchedule.dealerShiftDetails.shiftStart?this.datePipe.transform(this.appointmentSchedule.dealerShiftDetails.shiftStart, 'HH:mm'):"00:00";
    let shiftEndTime = this.appointmentSchedule.dealerShiftDetails.shiftEnd?this.datePipe.transform(this.appointmentSchedule.dealerShiftDetails.shiftEnd, 'HH:mm'):"00:00";
    // const startHours = +shiftStartTime?.split(":")[0];
    // const endHours = +(shiftEndTime?.split(":")[0]);
    const startHours = +EnvSetting.PlanningFromTime;
    const endHours = +EnvSetting.PlanningToTime
    for (let i = startHours; i <= endHours; i++) {
      this.hours.push(i);
    }
  }

  setTotalDuration(): void {
    this.totalDuration = 0;
    this.appointmentSchedule.bookedMechanicList.forEach(booking => {
      this.totalDuration += booking.duration;
    });
    this.formattedtotalDuration = Math.floor(this.totalDuration / 60) + '.' + (this.totalDuration % 60);
    const [h,m] = this.formattedtotalDuration.split('.');
        this.formattedtotalDurationDate = new Date();
        this.formattedtotalDurationDate.setHours(h);
        this.formattedtotalDurationDate.setMinutes(m);
  }
  async onAddBooking(isAdded: boolean): Promise<void> {
    if (isAdded) {
      await this.getAppointmentSchedule();
    }
  }

  async onShowAllMechanics(showAllMechanic: boolean): Promise<void> {
    this.showAllMechanic = showAllMechanic;
    await this.getMechaicMonthwiseHours(this.selectedDate);
    await this.getAppointmentSchedule(this.selectedDate);

  }
  async RefreshDayData() : Promise<void>{
    await this.getDealerWorkingHoursAndHolidayList()
    let dealerNotWorking = this.dealerWorkingHours.filter((x)=>(x.dayNumber == this.selectedDate.getDay()) && !x.open)
    this.dealerHolidayDates = [];
    this.dealerHolidays?.forEach(element => {
      for (const d = Utility.getDateStringToDate(element?.startDate); d <= Utility.getDateStringToDate(element?.endDate); d.setDate(d.getDate() + 1)) {
        this.dealerHolidayDates.push(new Date(d));
    }
    });
    let dealerHolidays = this.dealerHolidayDates?.filter((y) => Utility.GetFormattedDate(y) == Utility.GetFormattedDate(this.selectedDate))
     if(dealerNotWorking?.length > 0 || dealerHolidays?.length > 0 ){
       this.appointmentSchedule = null;
      this.daySchedulerViewModel = null;
       this.genericSchedulerListViewModel = null;
       await this.getMechaicMonthwiseHours(this.selectedDate);
       this.IsMessageDisplay = true;
       this.message = this.translate.instant("lblDealerNotAvailable")
       this.message += ' ' + Utility.GetFormattedDate(this.selectedDate);
     }
     else{
       this.IsMessageDisplay = false;
       await this.getMechaicMonthwiseHours(this.selectedDate);
      await this.getAppointmentSchedule(new Date(this.selectedDate));
    }
  }

  async onDayChange(data): Promise<void> {
    this.selectedDate = new Date(data?.actualDate);
    //this.selectedDate.setHours(0,0,0,0);
    if(data?.isHoliday)
    {
      this.appointmentSchedule = null;
      this.daySchedulerViewModel = null;
      this.genericSchedulerListViewModel = null;
      await this.getMechaicMonthwiseHours(this.selectedDate);
      this.IsMessageDisplay = true;
      this.message = this.translate.instant("lblDealerNotAvailable")
      this.message += ' ' + Utility.GetFormattedDate(this.selectedDate);
    }
    else{
      this.IsMessageDisplay = false;
      await this.getAppointmentSchedule(new Date(this.selectedDate));
    }
  }

  onEditMechanicBooking(id: number, date: Date, mechanicName: string, mechanicId: number, startTime: Date, endTime: Date, duration: number, efficiency:number): void {
    const modalref = this.model.open(AddBookingComponent, { size: 'lg' });
    modalref.componentInstance.mechanicName = mechanicName;
    modalref.componentInstance.startDate = date;
    modalref.componentInstance.pId = mechanicId;
    modalref.componentInstance.durationValue = this.duration;
    modalref.componentInstance.calenderStartDate = Utility.GetFormattedDate(new Date());
    modalref.componentInstance.mechanicStartTime = this.datePipe.transform(startTime, 'HH:mm');
    modalref.componentInstance.endTime = this.datePipe.transform(endTime, 'HH:mm');
    modalref.componentInstance.dealerId = this.dealerId;
    modalref.componentInstance.dealerWorkingHours = this.dealerWorkingHours;
    modalref.componentInstance.dealerHolidays = this.dealerHolidays;
    modalref.componentInstance.durationValue = duration;
    modalref.componentInstance.isEditMechancBooking = true;
    modalref.componentInstance.moduleId =  Enums.ModuleNames.Appointment;
    modalref.componentInstance.integrationWithDMS = false;
    modalref.componentInstance.realtimeDmsSyncAppointment = false;
    modalref.componentInstance.isAddBooking = true;
    modalref.componentInstance.mechanicEfficiency = efficiency;
    modalref.componentInstance.totalTimeDuration = this.remainingDuration;
    modalref.componentInstance.calendarNumber = this.calendarNumber;
    modalref.componentInstance.serviceDetail = this.serviceDetail;
    this.features = this.secureStorage.getKeyData('feature');
    if (this.features?.length > 0) {
      modalref.componentInstance.integrationWithDMS = this.features.find(x => x.featureCode === Enums.FeatureCode.DMS)?.isActive;
      modalref.componentInstance.realtimeDmsSyncAppointment = this.features.find(x => x.featureCode === Enums.FeatureCode.RTDSA)?.isActive;
    }
    modalref.componentInstance.saveAppointmentBooking = async (mechanicPlanningViewModel: SaveAppointmentPlanning) => {
      this.spinner.show();
      let isBookingAllowed = false;
      let isWARBookingAllowed = false;
      if(this.daySchedulerViewModel.mechanics.length > 0){
        let plannedData = this.daySchedulerViewModel.mechanics.filter(x=>x.mechanicId == mechanicId);
        let data = plannedData[0].bookedAppointmentList.filter(x=> x.isReserved)
        isBookingAllowed = this.checkReserveSlotAvailability(mechanicPlanningViewModel.startDateTime, mechanicPlanningViewModel.endDateTime, data)
        let WARdata = plannedData[0].bookedAppointmentList.filter(x => x.isunplanned)
        isWARBookingAllowed = this.checkReserveSlotAvailability(mechanicPlanningViewModel.startDateTime, mechanicPlanningViewModel.endDateTime, WARdata)
    }
      mechanicPlanningViewModel.appointmentId = this.appointmentId;
      mechanicPlanningViewModel.mechanicId = mechanicId;
      mechanicPlanningViewModel.bookingId = id;
        if (!isBookingAllowed && !isWARBookingAllowed){
        if (new Date(mechanicPlanningViewModel.startDateTimeToCompare).setHours(0,0,0,0) >= new Date().setHours(0,0,0,0)) {
        await this.appointmentPlanningService.UpdateAppointmentPlanningTime(mechanicPlanningViewModel)
          .then((response) => {
            this.spinner.hide();
            if (response) {
              const errorObject = response.responseObject.result;
             const msg = this.appointmentPlanningService.bookingErrorMessage(errorObject.errorCode);
              this.toastr.error(this.translate.instant(msg))
            } else {
              this.toastr.success(fromEnums.ToastrMessages.SaveMechanicBooking);
              this.onAddBooking(true);
              modalref.close();
            }
          });
        }
        else{
          this.toastr.error(this.translate.instant("lblCanNotAddPlanningForPreviousDate"));
        }
        }
          else{
            this.toastr.error(this.translate.instant("lblCanNotAddPlanningForPreviousDate"));
          }
    this.spinner.hide();
  }

  }

  checkReserveSlotAvailability(startTime,endTime,reserveSlot){
    let offTime:boolean = false;
    if(reserveSlot?.length > 0){
        for(let value of reserveSlot)
        {
            if(new Date(startTime).getTime() >= value.appointmentStartTime.getTime() && new Date(startTime).getTime() < value.appointmentEndTime.getTime())
            {
                offTime = true;
                break;
            }
            if(new Date(endTime).getTime() > value.appointmentStartTime.getTime() && new Date(endTime).getTime() < value.appointmentEndTime.getTime())
            {
                offTime = true;
                break;
            }
        }
    }
    return offTime;
}
  
  onLoadErrorMessage(planningDateTime: any) {
  this.loadErrorMessage.emit(planningDateTime);
  }
 
  OnClose() {
    this.activeModal.close({success: false});
  }

  onDeleteMechanicBooking(content,appointment) {
    this.features = this.secureStorage.getKeyData('feature');
    let takeReasonForDeletePlanning = false;
    if (this.features?.length > 0)
    {
        takeReasonForDeletePlanning=this.features.find(x => x.featureCode === Enums.FeatureCode.ReasonForDeletePlanning)?.isActive;
    }
    if(takeReasonForDeletePlanning)
    {
        this.DeleteMechanicBookingWithReason(content,appointment);
    }
    else{
        this.DeleteMechanicBookingWithOutReason(appointment);
    }
  }
  DeleteMechanicBookingWithReason(content,appointment) {
    this.bookingId = appointment;
    this.modalService.open(content, { size: 'md', ariaLabelledBy: 'modal-basic-title' }).result.then(async (result) => {
        this.closeResult = `Closed with: ${result}`;
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
    
  }
  async deleteMechanicBooking(appointment): Promise<void> {
    this.spinner.show();
    let intergrationWithDMS,realtimeDmsSyncAppointment,takeReasonForDeletePlanning = false;
    this.features = this.secureStorage.getKeyData('feature');
    if (this.features?.length > 0)
    {
        intergrationWithDMS=this.features.find(x => x.featureCode === Enums.FeatureCode.DMS)?.isActive;
        realtimeDmsSyncAppointment=this.features.find(x => x.featureCode === Enums.FeatureCode.RTDSA)?.isActive;
        takeReasonForDeletePlanning=this.features.find(x => x.featureCode === Enums.FeatureCode.ReasonForDeletePlanning)?.isActive;
    }
    let viewModel = {
        AppointmentId: 0,
        BookingId: 0,
        IntegrationWithDMS: intergrationWithDMS,
        RealtimeDmsSyncAppointment: realtimeDmsSyncAppointment,
        ModuleId: Enums.ModuleNames.Appointment,
        Reason: this.reasonForDelete
      }
    if(takeReasonForDeletePlanning)
    {
        viewModel.AppointmentId = this.appointmentId;
        viewModel.BookingId = this.bookingId;
    }
    else{
        viewModel.AppointmentId = this.appointmentId;
        viewModel.BookingId = appointment;
    }
    if(viewModel.AppointmentId > 0 && viewModel.BookingId > 0){
        await this.appointmentPlanningService.DeleteAppointmentPlanning(viewModel)
        .then((response) => {
          if (response) {
            const errorObject = response.responseObject.result;
            if (errorObject.errorCode === fromEnums.ErrorCodes.ParamInvalid) {
              this.toastr.error(fromEnums.ToastrMessages.ParamInvalid);
            } else if (errorObject.errorCode === fromEnums.ErrorCodes.DataNotFound) {
              this.toastr.error(fromEnums.ToastrMessages.NoMechanicAvailable);
            }
            else if (errorObject.errorCode === fromEnums.ErrorCodes.InvalidIdCode) {
              let errorMessage = this.translate.instant("lblMechanicIsInClockIn");
              this.toastr.error(errorMessage);
            }
          } else {
            this.toastr.success(fromEnums.ToastrMessages.MechanicBookingDeleted);
            this.onAddBooking(true);
          }
          this.spinner.hide();
          this.reasonForDelete = '';
          this.bookingId = 0;
        });
    }
  }

  DeleteMechanicBookingWithOutReason(appointment) {
    let modelHeadermsg = this.translate.instant("lblDelete");
    let modelBodymsg = Utility.createMessage(this.translate.instant("lblSureToDelete"),this.translate.instant("lblPlanning"),false);
    const modalRef = this.model.open(NgbdModalContent);
    modalRef.componentInstance.modelHeader = modelHeadermsg;
    modalRef.componentInstance.modelBody = modelBodymsg;
    modalRef.result.then((_result) => {
       // This is intentional
     }, async (reason) => {
      const popupCloseResult = this.getDismissReason(reason);
      if (popupCloseResult) {
        await this.deleteMechanicBooking(appointment);
      }
    });
  }
  async reloadBookings() {
    await this.getMechaicMonthwiseHours(new Date(this.todayDate));
    await this.getAppointmentSchedule(new Date(this.todayDate));
  }
  private getDismissReason(reason: any): boolean {
    if (reason === ModalDismissReasons.ESC) {
      return false;
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return false;
    } else {
      return reason;
    }
  }
  private schedulerResourceMapper(mechanicData: any): any[] {
    let superArray = [];
    if (mechanicData.length > 0) {
      mechanicData.forEach(element => {
        let supper = Object();
        supper.brands = element.brandIcon;
        supper.mechanicName = element.mechanicName;
        supper.mechanicId = element.mechanicId;
        supper.skillDescription = element.skillDescription
        supper.mechanicEfficiency = element.mechanicEfficiency
        supper.shiftInfo = this.appointmentPlanningService.CommonFilterMechanicShift(element.mechanicId, mechanicData, this.selectedDate);
        superArray.push(supper);
        this.calendarNumber = element.calendarNumber
      });
    }
    return superArray.sort((a, b) => a.mechanicName.localeCompare(b.mechanicName));
  }

  private schedulerEventMapper(eventInfo: any, mechanicInfo) {
    const offset = new Date().getTimezoneOffset();
    let superArray = [];
    let temp = [];
    if (eventInfo.length > 0) {
      superArray = eventInfo.filter(x => this.datePipe.transform(x.startDate, 'yyyy-MM-dd') === this.datePipe.transform(this.selectedDate, 'yyyy-MM-dd'));
    }
    //Bind Events from other workorders
    if (mechanicInfo.length > 0) {
      mechanicInfo.forEach(element => {
        element.bookedAppointmentList.forEach(el => {
          let eventInfo = Object();
          eventInfo.bookingId = el.appointmentId;
          eventInfo.startTime = new Date(new Date(el.appointmentStartTime).getTime() - (offset * 60 * 1000));
          eventInfo.endTime = new Date(new Date(el.appointmentEndTime).getTime() - (offset * 60 * 1000));
          eventInfo.startDate = new Date(el.appointmentStartTime);
          eventInfo.mechanicId = element.mechanicId;
          eventInfo.mechanicName = element.mechanicName;
          eventInfo.licensePlate = el.licensePlate;
          eventInfo.customerName = el.customerName;
          eventInfo.workOrderNo = el.workOrderNo;
          eventInfo.mechanicEfficiency = element.mechanicEfficiency
          eventInfo.duration = ((this.calculateTimeDiff(new Date(el.appointmentStartTime), new Date(el.appointmentEndTime))) * 60);
          if (superArray.length > 0) {
            temp = superArray.filter(x => this.datePipe.transform(x.startTime, 'yyyy-MM-dd HH:mm') === this.datePipe.transform(eventInfo.startTime, 'yyyy-MM-dd HH:mm') &&
              this.datePipe.transform(x.endTime, 'yyyy-MM-dd HH:mm') === this.datePipe.transform(eventInfo.endTime, 'yyyy-MM-dd HH:mm') && x.mechanicId === eventInfo.mechanicId);
            if (temp.length === 0) {
              superArray.push(eventInfo);
            }
          } else {
            superArray.push(eventInfo);
          }
          temp = [];
        });
      });
    }
    return superArray;
  }

  private calculateTimeDiff(start: any, end: any): any {
    let baseDiff = (end - start);
    return (baseDiff % 86400000) / 3600000;
  }


}
